// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-contactpg-js": () => import("./../../../src/pages/contactpg.js" /* webpackChunkName: "component---src-pages-contactpg-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-projectspg-js": () => import("./../../../src/pages/projectspg.js" /* webpackChunkName: "component---src-pages-projectspg-js" */),
  "component---src-pages-skillpg-js": () => import("./../../../src/pages/skillpg.js" /* webpackChunkName: "component---src-pages-skillpg-js" */)
}

